import { type FC } from 'react';
import ProductSize from '../../../ProductSize/ProductSize';
import style from './ProductSizeView.module.scss?module';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import ProductAnimationContainer from '../../ProductAnimationContainer';
import clsx from 'clsx';

type ProductSizeViewPropsT = {
  data: ProductSizeInterface[];
  allowBackorder?: boolean;
};

const ProductSizeView: FC<ProductSizeViewPropsT> = ({
  data,
  allowBackorder = false,
}) => {
  return (
    <div className={style.ProductsContainer}>
      <ul className="px-0">
        <ProductAnimationContainer
          items={data}
          view="grid"
          renderItem={(product, index) => (
            <div className={clsx(index !== 0 ? 'pt-4 pt-lg-5' : 'pt-3')}>
              <ProductSize
                product_size={product}
                brand={product.product?.brand}
                key={product.id}
                allowBackorder={allowBackorder}
              />
            </div>
          )}
        />
      </ul>
    </div>
  );
};

export default ProductSizeView;
